import { InjectionToken, Provider } from '@angular/core';
import { CallbackForm } from '@callback/const';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CALLBACK, CallbackState } from '../callback-state';

export function getReducers(): ActionReducerMap<CallbackState> {
  return {
    callback: StateUtils.loaderReducer<CallbackForm>(CALLBACK),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CallbackState>> = new InjectionToken<
  ActionReducerMap<CallbackState>
>('CallbackReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
